import { API_HOST, getHttpPostOptions, getHttpPutOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/login`;

export const getLoginRequest = (user) => [getEndpoint(), getHttpPostOptions(user)];

const getSendResetPasswordEmailEndpoint = (email) => `${getEndpoint()}/send/reset-password-email/${email}`;
export const getSendResetPasswordEmailRequest = (email) => [
  getSendResetPasswordEmailEndpoint(email),
  getHttpPostOptions(),
];

const getResetPasswordEndpoint = () => `${getEndpoint()}/update/password`;
export const getResetPasswordRequest = (input) => [getResetPasswordEndpoint(), getHttpPutOptions(input)];
